<template>
  <section class="special-section overlay-animation" :class="getClasses">
    <div class="section-box p-4 lg:p-3 xl:p-12 xl:pt-8" :class="getClasses">
      <div
        v-if="!disableLabel"
        class="label"
        :class="[getDataByModel?.labelBgColor, getClasses]"
      >
        <slot name="badge">
          {{ data?.card_label || getDataByModel?.label }}
        </slot>
      </div>
      <div class="content-wrapper">
        <div
          class="title-project max-w-[1030px] md:text-[36px] md:leading-[43px] lg:text-[44px] lg:leading-[53px] xl:text-[68px] xl:leading-[82px]"
          :class="getClasses"
        >
          {{ data?.title }}
        </div>
        <div
          class="announce-project mt-3 max-w-[829px] text-[16px] leading-[22px] lg:text-[18px] lg:leading-[25px] xl:text-[24px] xl:leading-[34px]"
          :class="getClasses"
        >
          {{ data?.announce }}
        </div>
        <div class="control" :class="getClasses">
          <div class="swiper-box relative w-full" :class="getClasses">
            <ClientOnly v-if="type !== 'fourth'">
              <div>
                <Swiper :breakpoints="breakpoints" @swiper="onSwiper">
                  <SwiperSlide
                    v-for="(item, itemIndex) in data.gallery"
                    :key="itemIndex"
                    class="swiper-slide"
                    :class="getClasses"
                  >
                    <div
                      v-if="item.label"
                      class="absolute left-0 top-[16px] z-20 rounded-r-[4px] py-px pl-[12px] pr-[4px] text-[12px] font-bold uppercase leading-[15px] text-white-100 xl:text-[14px] xl:leading-[17px]"
                      :class="getDataByModel?.labelBgColor"
                    >
                      <slot name="badge">
                        {{ item.label }}
                      </slot>
                    </div>
                    <a
                      :href="item.link || 'javascript:void(0)'"
                      :target="item.link && '_blank'"
                    >
                      <img
                        v-lazy-load
                        :src="
                          item.static
                            ? `/imgs/projects/${item.static}/${item.previewSrc}`
                            : item.previewSrc
                        "
                        alt=""
                        class="size-full rounded-xl object-cover object-center"
                        :class="getClasses"
                      />
                      <p
                        class="mt-[7px] text-center text-[14px] font-medium leading-[18px] md:text-[12px] md:leading-[16px] lg:text-[14px] lg:leading-[18px] xl:text-[16px] xl:leading-[22px]"
                      >
                        {{ item.title }}
                      </p>
                      <BaseTheButtonNew
                        v-if="type === 'third'"
                        :text="'Читать'"
                        type="transparent"
                        class="lg-[14px] mx-auto max-h-[26px] max-w-[78px] rounded-[6px] px-4 py-[6px] text-[12px] sm:max-w-[initial] md:max-h-[24px] md:text-[12px] lg:mt-[5px] lg:max-h-[26px] xl:mt-[13px] xl:max-h-[49px] xl:rounded-[8px] xl:px-[32px] xl:py-[16px] xl:text-[14px] xl:leading-[17px]"
                      />
                    </a>
                  </SwiperSlide>
                </Swiper>
              </div>
            </ClientOnly>

            <div
              v-else
              class="mb-4 grid grid-cols-2 justify-center justify-items-center gap-2 sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5"
            >
              <div
                v-for="(item, itemIndex) in data.gallery"
                :key="itemIndex"
                class="swiper-slide"
                :class="getClasses"
              >
                <div
                  v-if="item.label"
                  class="absolute left-0 top-[16px] z-20 rounded-r-[4px] py-px pl-[12px] pr-[4px] text-[12px] font-bold uppercase leading-[15px] text-white-100 xl:text-[14px] xl:leading-[17px]"
                  :class="getDataByModel?.labelBgColor"
                >
                  <slot name="badge">
                    {{ item.label }}
                  </slot>
                </div>
                <a
                  :href="item.link || 'javascript:void(0)'"
                  :target="item.link && '_blank'"
                >
                  <img
                    v-lazy-load
                    :src="
                      item.static
                        ? `/imgs/projects/${item.static}/${item.previewSrc}`
                        : item.previewSrc
                    "
                    alt=""
                    class="size-full rounded-xl object-cover object-center"
                    :class="getClasses"
                  />
                  <p
                    class="mt-[7px] text-center text-[14px] font-medium leading-[18px] md:text-[12px] md:leading-[16px] lg:text-[14px] lg:leading-[18px] xl:text-[16px] xl:leading-[22px]"
                  >
                    {{ item.title }}
                  </p>
                  <BaseTheButtonNew
                    :text="'Читать'"
                    type="transparent"
                    class="lg-[14px] mx-auto max-h-[26px] max-w-[78px] rounded-[6px] px-4 py-[6px] text-[12px] sm:max-w-[initial] md:max-h-[24px] md:text-[12px] lg:mt-[5px] lg:max-h-[26px] xl:mt-[13px] xl:max-h-[49px] xl:rounded-[8px] xl:px-[32px] xl:py-[16px] xl:text-[14px] xl:leading-[17px]"
                  />
                </a>
              </div>
            </div>

            <SlidersSliderControl
              type="prev"
              class="slider-control-prev absolute z-10 hidden md:block"
              :class="[
                isBeginning ? 'opacity-50' : 'cursor-pointer',
                getClasses,
              ]"
              @click="slidePrev()"
            />
            <SlidersSliderControl
              type="next"
              class="slider-control-next absolute z-10 hidden md:block"
              :class="[isEnd ? 'opacity-50' : 'cursor-pointer', getClasses]"
              @click="slideNext()"
            />
          </div>
          <a :href="data.link" target="_blank" class="mt-auto h-fit">
            <BaseTheButtonNew
              text="Подробнее"
              type="secondary"
              class="button-special"
              :class="getClasses"
            />
          </a>
        </div>
        <div
          v-if="type !== 'fourth'"
          class="mx-auto mb-[34px] mt-auto flex w-fit items-center md:hidden"
        >
          <SlidersSliderDot
            v-for="i in data.gallery.length"
            :key="`dot-${i}`"
            class="mr-2 last:mr-0"
            :class="{ active: currentItemIndex + 1 === i }"
            @click="slideTo(i - 1)"
          />
        </div>
      </div>
    </div>
    <img
      v-lazy-load
      :src="
        data.previewSrc
          ? `/imgs/projects/${data.previewSrc}`
          : '/imgs/default-image.png'
      "
      alt=""
      class="absolute inset-0 -z-1 size-full object-cover"
    />
  </section>
</template>

<script setup>
import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/vue';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },

  disableLabel: { type: Boolean, default: false },

  type: {
    type: String,
    default: 'first',
    validate: (value) => ['first, second, third'].includes(value),
  },
});

const getCardSettings = useCardSettings();
const { isBeginning, isEnd, onSwiper, slideNext, slidePrev, slideTo } =
  useSwiper();

const currentItemIndex = ref(0);

const breakpoints =
  props.type === 'second'
    ? {
        768: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 12,
        },
      }
    : {
        768: {
          slidesPerView: 5,
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 12,
        },
      };

const getDataByModel = computed(() => {
  return getCardSettings(props.data);
});

const getClasses = computed(() => {
  switch (props.type) {
    case 'second':
      return 'type_second';
    case 'third':
      return 'type_third';
    case 'fourth':
      return 'type_fourth';
    default:
      return 'type_first';
  }
});
</script>

<style lang="scss">
.special-section {
  @apply relative text-white-100 min-w-full w-full rounded-xl shadow-drop-0 h-full overflow-hidden mb-10 font-roboto;
  &.type_first,
  &.type_second,
  &.type_third {
    @apply max-h-[637px] min-h-[637px] md:max-h-[402px] md:min-h-[402px] lg:max-h-[544px] lg:min-h-[544px] xl:max-h-[845px] xl:min-h-[845px];
  }
}
.section-box {
  &.type_first,
  &.type_second,
  &.type_third {
    @apply absolute inset-0;
  }
  .content-wrapper {
    @apply flex flex-col h-full;
  }
}
.label {
  @apply py-[2px] px-[8px] rounded text-[14px] leading-[17px] font-bold text-white-100 uppercase z-20 w-fit;
}
.label.type_first,
.label.type_third,
.label.type_fourth {
  @apply mx-auto;
}
.label.type_second {
  @apply mx-auto xl:mx-[initial] xl:absolute top-[32px] left-[48px];
}
.control.type_first .control.type_third .control.type_fourth {
  @apply flex flex-col;
}
.control.type_second {
  @apply flex flex-row-reverse mt-[30px] sm:mt-auto mb-[37px];
}
.slider-control-prev.type_first,
.slider-control-prev.type_third {
  @apply top-[50%] translate-y-[-50%] left-[-48px];
}
.slider-control-next.type_first,
.slider-control-next.type_third {
  @apply top-[50%] translate-y-[-50%] right-[-48px];
}
.slider-control-prev.type_second {
  @apply top-[50%] translate-y-[-50%] left-[-48px] xl:top-[-48px] xl:translate-y-[0%] xl:right-[40px] xl:left-[initial];
}
.slider-control-next.type_second {
  @apply top-[50%] translate-y-[-50%] right-[-48px] xl:top-[-48px] xl:translate-y-[0%] xl:right-0;
}
.slider-control-prev.type_fourth,
.slider-control-next.type_fourth {
  @apply hidden;
}
.swiper-box.type_first {
  @apply max-w-[326px] md:max-w-[572px] lg:max-w-[772px] 2xl:max-w-[978px] mx-auto;
}
.swiper-box.type_third {
  @apply max-w-[326px] md:max-w-[611px] lg:max-w-[847px] 2xl:max-w-[1208px] mx-auto;
}
.swiper-box.type_second {
  @apply max-w-[326px] md:max-w-[556px] lg:max-w-[808px] 2xl:max-w-[863px] mx-auto xl:ml-auto xl:mr-[initial];
}
.swiper-box.type_fourth {
  @apply max-w-[326px] sm:max-w-[490px] md:max-w-[611px] lg:max-w-[847px] 2xl:max-w-[1208px] mx-auto;
}
.title-project.type_first,
.title-project.type_third,
.title-project.type_fourth {
  @apply text-center mx-auto mt-[37px] text-[32px] leading-[35px] xl:text-[68px] xl:leading-[82px] md:mt-[11px] xl:mt-[90px] lg:mt-[63px];
}
.title-project.type_second {
  @apply text-center text-[28px] xl:text-[68px] leading-[31px] xl:leading-[75px] xl:text-left mt-[37px] md:mt-[35px] lg:mt-[112px] xl:mt-[240px];
}
.announce-project.type_first,
.announce-project.type_third,
.announce-project.type_fourth {
  @apply text-center mx-auto mb-[48px] md:mb-[28px] lg:mb-[52px] xl:mb-14;
}
.announce-project.type_second {
  @apply text-center mx-auto xl:text-left xl:mx-[initial];
}
.button-special.type_first {
  @apply hidden xl:block mt-[81px] mx-auto;
}
.button-special.type_second {
  @apply hidden xl:block mt-auto h-fit;
}
.button-special.type_third,
.button-special.type_fourth {
  @apply hidden;
}
.swiper-slide.type_first {
  @apply h-full max-w-[159px] md:max-w-[108px] md:max-h-[190px] lg:max-h-[234px] lg:max-w-[148px] xl:max-w-[186px] xl:max-h-[287px];
}
.swiper-slide.type_second {
  @apply h-full max-w-[326px] max-h-[228px] md:max-w-[180px] md:max-h-[135px] lg:max-h-[190px] lg:max-w-[264px] xl:max-w-[280px] xl:max-h-[209px];
}
.swiper-slide.type_third {
  @apply max-w-[159px] md:max-w-[116px] lg:max-w-[163px] xl:max-w-[232px];
}
.swiper-slide.type_third,
.swiper-slide.type_fourth {
  @apply h-full md:max-h-[192px] lg:max-h-[263px] xl:max-h-[392px];
}
.swiper-slide.type_fourth {
  @apply max-w-[159px] lg:max-w-[163px] xl:max-w-[232px];
  @apply md:min-h-[253px] lg:min-h-[263px] xl:min-h-[392px];
}
.swiper-slide.type_first > a > img {
  @apply min-h-[222px] max-h-[222px] md:min-h-[150px] md:max-h-[150px] lg:min-h-[204px] lg:max-h-[204px] xl:min-h-[225px] xl:max-h-[258px];
}
.swiper-slide.type_second > a > img {
  @apply min-h-[180px] max-h-[180px] md:min-h-[99px] md:max-h-[99px] lg:min-h-[146px] lg:max-h-[146px] xl:min-h-[153px] xl:max-h-[153px];
}
.swiper-slide.type_third > a > img {
  @apply min-h-[222px] max-h-[222px] md:min-h-[160px] md:max-h-[160px] lg:min-h-[225px] lg:max-h-[225px] xl:min-h-[225px] xl:max-h-[323px];
}
.swiper-slide.type_fourth > a > img {
  @apply min-h-[222px] max-h-[222px] lg:min-h-[225px] lg:max-h-[225px] xl:min-h-[225px] xl:max-h-[323px];
}
</style>
